module.exports = __webpack_public_path__ + "static/img/fa.3a33e27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fa.png
// module id = gbeC
// module chunks = 1